<div class="content">
  <div class="table-container mat-elevation-z3">

    <table mat-table [dataSource]="items" matSort matSortActive="printerNo" matSortDirection="asc" matSortDisableClear
      [matSortDirection]="sortDirection" [matSortActive]="sortColumn" (matSortChange)="onSortData($event)">

      <ng-container matColumnDef="brands">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.brand' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="brand">
            <img class="logo" [src]="brandService.getLogoById(element.shop.brandId)" />
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="shopNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.shop-number' | translate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.shop.shopNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="shopName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.shop-name' | translate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.shop.shopName}} </td>
      </ng-container>

      <ng-container matColumnDef="printerNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.printer-number' | translate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.uniqueNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="printerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.printers.name' | translate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>

      <ng-container matColumnDef="evidenceNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.printers.evidence-number' | translate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.evidenceNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="printerIp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.printers.ip-address' | translate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.ip}} </td>
      </ng-container>

      <ng-container matColumnDef="printerPort">
        <th mat-header-cell *matHeaderCellDef> {{'administration.printers.port' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.port}} </td>
      </ng-container>

      <ng-container matColumnDef="printerType">
        <th mat-header-cell *matHeaderCellDef> {{'administration.printers.type' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.printerType}} </td>
      </ng-container>

      <ng-container matColumnDef="dateFrom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.date-from' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.dateFrom | date: 'yyyy-MM-dd HH:mm'}} </td>
      </ng-container>

      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.active' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="element.isActive; then thenBlock else elseBlock"></div>
          <ng-template #thenBlock>
            <span class="icon-active">
              <fa-icon [icon]="faCheck" size="lg"></fa-icon>
            </span>
          </ng-template>
          <ng-template #elseBlock>
            <span class="icon-inactive">
              <fa-icon [icon]="faTimes" size="lg"></fa-icon>
            </span>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> {{'common.actions' | translate}} </th>
        <td mat-cell *matCellDef="let element;">
          <div class="row">
            <button mat-mini-fab color="primary" matTooltip="{{'administration.printers.edit' | translate}}"
              aria-label="Edit printer" (click)="addOrEditPrinterOpenDialog(element)" *ngIf="authService.hasPermission(permissionEnum.EditPrinter)">
              <fa-layers [fixedWidth]="true">
                <fa-icon [icon]="faPrint" transform="left-3 up-2"></fa-icon>
                <fa-icon [icon]="faPen" transform="shrink-7 down-3 right-8"></fa-icon>
              </fa-layers>
            </button>
            <button mat-mini-fab color="primary" matTooltip="{{'administration.printers.history' | translate}}"
              aria-label="Printer history" *ngIf="element.id" (click)="onPrinterHistoryOpenDialog(element.id)">
              <fa-icon [icon]="faHistory"></fa-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container *ngFor="let column of columns" [matColumnDef]="column.filter.name">
        <th mat-header-cell *matHeaderCellDef="let element">
          <app-table-filter #filterRefs [column]="column" [filter]="filter" (filterChange)="filterData($event)"></app-table-filter>
        </th>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="filters"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

    <div class="empty-results" *ngIf="items.length === 0">{{'common.empty-results' | translate}}
    </div>

    <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageIndex]="pageIndex" color="primary"
      [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event; onPaginateChange($event)" showFirstLastButtons
      class="mat-paginator-row">
    </mat-paginator>
  </div>
</div>